import { emperor } from '~/services';

export type CocStatus = 'pass' | 'fail' | 'gray area';
export type CocResult = { status: CocStatus; reasoning: string };

export const evaluateCommentAgainstCoC = async (
  content: string
): Promise<CocResult> => {
  const response = await emperor.post('evaluate-coc', { content });
  return response.data;
};
